import React, { useState, useEffect, memo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { persistor } from "../../../store/store";
import { resetAllFormDetails, setFlyFromAndTo } from "../../../services/slices/addFlightShopSlice";
import BulkImport from "../bulk-import";
import AddFlightShopForm from "./child-components/flight-shop-form";
import SearchFlightShopForm from "./child-components/search-flight-shop-form";
import Spinner from "../../../layout/spinner/spinner";
import { type } from "../../../utils/constants/constants";
import { clearAllReduxStates } from "../../../utils/common-hooks/clearState";
import { setLogoutSession } from "../../../services/slices/authTokenSlice";
import { resetFormOptions, setFlightroute, setForm1Options, setForm2Options, setForm3Options } from "../../../services/slices/addformSlice";
import { responseData } from "../../../utils/helpers/helper";

const AddFlightShop = () => {

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { shopid } = useParams();

  const { state } = location;

  const { airPorts } = useSelector((state) => state.airports);
  const { addFlightShop: { searchDestination: { flyFrom, flyTo } } } = useSelector((state) => state.addFlightShop);
  const { form3Options } = useSelector(state => state?.addShop);
  const { userdetails } = useSelector(state => state.userDetails);

  const yourAirlineOptions = useSelector(state => state?.userAirline?.userAirline);
  const brandOptions = useSelector(state => state?.source?.sourceDatas?.carrier);
  const metaOtaOptions = useSelector(state => state?.source?.sourceDatas?.source);
  const [isShowinsert, setIsShowinsert] = useState(false);
  const [isShowDownload, setIsShowDownload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [isEditDataFetched, setIsEditDataFetched] = useState(false);
  const [isFromPreviousPage, setIsFromPreviousPage] = useState(false);
  const [selVal, setSelVal] = useState({ from: "", to: "" })

  useEffect(() => {
    if (shopid === "new") {
      setActiveStep(0)
      dispatch(setFlightroute({
        flyFrom: "",
        flyTo: "",
      }))
      dispatch(resetFormOptions()); // Ensure dispatch is called
      setSelVal(
        { from: "", to: "" }
      )
    }
    // eslint-disable-next-line
  }, [shopid]);

  useEffect(() => {
    dispatch(resetAllFormDetails());
    if (typeof shopid === type?.string && shopid !== "new" && !isNaN(parseInt(shopid))) {
      fetchEditShopDatas();
    }else{
      dispatch(setForm3Options({ ...form3Options, timeZone: userdetails?.userTimezone })); // Dispatch the latest state

    }
    // eslint-disable-next-line
  }, []);

  const setFlyFromAndFlyTo = (result) => {
    let tempFlyFrom = airPorts?.filter((i) => i.airportiata === (result[0]?.flyFrom) || i.cityiata === (result[0]?.flyFrom))
      .map((i) => {
        const cityNameWithoutSpaces = i?.cityname?.replace(/ /g, '');
        const isCityMatch = i.cityiata === result[0]?.flyFrom && i.airportiata !== result[0]?.flyFrom;
        return `${cityNameWithoutSpaces} - ${isCityMatch ? i?.cityiata : i?.airportiata}`;
      });

    let tempFlyTo = airPorts?.filter((i) => i.airportiata === (result[0]?.flyTo) || i.cityiata === (result[0]?.flyTo))
      .map((i) => {
        const cityNameWithoutSpaces = i?.cityname?.replace(/ /g, '');
        const isCityMatch = i.cityiata === result[0]?.flyTo && i.airportiata !== result[0]?.flyTo;
        return `${cityNameWithoutSpaces} - ${isCityMatch ? i?.cityiata : i?.airportiata}`;
      });

    dispatch(
      setFlyFromAndTo({
        flyFrom: tempFlyFrom?.[0],
        flyTo: tempFlyTo?.[0],
      })
    );
  };

  useEffect(() => {
    return (() => {
      dispatch(setFlightroute({
        flyFrom: "",
        flyTo: "",
      }))
      dispatch(resetFormOptions()); // Ensure dispatch is called
    })
    // eslint-disable-next-line
  }, [])

  const fetchEditShopDatas = async () => {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    try {
      setLoading(true)
      const results = await axios.get(
        `${process.env.REACT_APP_API_URL}${`market/${shopid}`}`,
        config
      );
      const result = responseData(results)
      if (results?.status === 200) {
        let tempFlyFrom = airPorts?.filter((i) => i.airportiata === (result[0]?.flyFrom) || i.cityiata === (result[0]?.flyFrom))
          .map((i) => {
            const cityNameWithoutSpaces = i?.cityname?.replace(/ /g, '');
            const isCityMatch = i.cityiata === result[0]?.flyFrom && i.airportiata !== result[0]?.flyFrom;
            return `${cityNameWithoutSpaces} - ${isCityMatch ? i?.cityiata : i?.airportiata}`;
          });

        let tempFlyTo = airPorts?.filter((i) => i.airportiata === (result[0]?.flyTo) || i.cityiata === (result[0]?.flyTo))
          .map((i) => {
            const cityNameWithoutSpaces = i?.cityname?.replace(/ /g, '');
            const isCityMatch = i.cityiata === result[0]?.flyTo && i.airportiata !== result[0]?.flyTo;
            return `${cityNameWithoutSpaces} - ${isCityMatch ? i?.cityiata : i?.airportiata}`;
          });

        dispatch(setFlightroute({
          flyFrom: tempFlyFrom?.[0],
          flyTo: tempFlyTo?.[0],
        }))
        dispatch(setForm1Options({
          yourAirline: yourAirlineOptions.filter(data => result[0]?.carriers.includes(data?.airlineCode)).map(dt => dt.airlineCode),
          brands: brandOptions.filter(data => result[0]?.carriers.includes(data?.code)).map(dt => dt.code),
          ota: metaOtaOptions.filter(data => result[0]?.sources.includes(data?.code) && data.sourceType === "OTA").map(dt => dt.code),
          gds: metaOtaOptions.filter(data => result[0]?.sources.includes(data?.code) && data.sourceType === "GDS").map(dt => dt.code),
          meta: metaOtaOptions.filter(data => result[0]?.sources.includes(data?.code) && data.sourceType === "Metasource").map(dt => dt.code),
          rateparity: metaOtaOptions.filter(data => result[0]?.sources.includes(data?.code) && data.sourceType === "Metasource").map(dt => dt.code)?.length ? ["Yes"] : [],
          isAncillary: result[0]?.isAncillary ? ["Yes"] : ["No"],
          // isDeepsearch: result[0]?.isDeepsearch ? ["Yes"] : ["No"],
        }));
        dispatch(setForm2Options({
          route: result[0].routeType?.rtType === 1 ? "OW" : "RT",
          los: result[0].routeType?.los, // Length of Stay (only visible when "RT" is selected)
          cabinClass: result[0].cabinClass[0] === 1 ? "Economy" : result[0].cabinClass[0] === 2 ? "Business" : result[0].cabinClass[0] === 3 ? "First Class" : "Premium Economy",
          adults: result[0].pax?.adults,
          infants: result[0].pax?.infants,
          pos: result[0]?.pos,
          currency: result[0].currency,
          maxStops: result[0].maxStops === -1 ? "All" : result[0].maxStops === 0 ? "0" : result[0].maxStops,
          maxDuration: result[0].maxDuration === -1 ? "All" : result[0].maxDuration,
          startDate: result[0].horizonStartDate,
          endDate: result[0].horizonEndDate,
          customDay: result[0].customHorizon[0] !== undefined && result[0].customHorizon[0] !== null ? String(result[0].customHorizon[0]) : result[0].customHorizon[0],
          history: result[0].historicalData ? ["yes"] : [],
          historicalHorizon: result[0].historicalHorizon,
          horizonDays: result[0]?.horizonDays,
        }));

        dispatch(setForm3Options({
          frequency: result[0]?.frequency?.refresh,
          startDate: state.cloneflightkey && result[0]?.frequency?.startDate < new Date().toISOString().split('T')[0]
            ? null
            : result[0]?.frequency?.startDate,
          weekDays: result[0]?.frequency?.refresh === "Weekly" ? result[0]?.frequency?.days : [],
          monthDays: null,
          monthDaysAdd: result[0]?.frequency?.refresh === "Monthly" ? result[0]?.frequency?.days : [],
          customAdd: result[0]?.frequency?.refresh === "Custom" ? result[0]?.frequency?.customFrequency.map((item) => {
            let returnValue
            if (item.days.length && item.dateWeek.length) {
              returnValue = `${item.days.join(',')}/${item.dateWeek[0]}`;
            } else if (!item.days.length && item.dateWeek.length) {
              return item.dateWeek[0];
            } else {
              return ''
            }
            return returnValue
          }) : [],
          timeZone: result[0]?.frequency?.time?.[0].timeZone,
          time: "",
          deliveryzone: result[0]?.frequency?.time,
          needEndDate: result[0]?.frequency?.endDate ? "Yes" : "No",
          endDate: state.cloneflightkey && result[0]?.frequency?.startDate < new Date().toISOString().split('T')[0]
            ? null
            : result[0]?.frequency?.endDate,
          shopName: result[0]?.shopName,
          existShopName: result[0]?.shopName,
          charts: result[0]?.isVisualizeShop ? ["Yes"] : ["No"],
          chartsExist: result[0]?.isVisualizeShop ? ["Yes"] : ["No"]

        }))
        setIsEditDataFetched(true)
        setFlyFromAndFlyTo(result);
        setLoading(false)
      }
    } catch (error) {
      if (error?.response?.status === 401 && responseData(error?.response)?.message === "New login found.") {
        dispatch(setLogoutSession(true));
      } else if (error?.response?.status === 401) {
        clearAllReduxStates(dispatch)
        persistor.purge();
        sessionStorage.clear();
        localStorage.clear();
        navigate("/")
      }
    }
  };

  const handleCloseBulkSection = () => {
    setIsShowDownload(false)
    setIsShowinsert(false)
  }
  const addFlightShopFormRenderCondition = brandOptions?.length > 0 || metaOtaOptions?.length > 0;

  return (
    <div className="no-translate">
      {loading ? <Spinner /> : <div>
        <h1 className="dashboard-header">
          {" "}
          {shopid !== "new" &&
            typeof parseInt(shopid) === type?.number &&
            !state?.cloneflightkey
            ? "Edit Shop"
            : shopid !== "new" &&
              typeof parseInt(shopid) === type?.number &&
              state?.cloneflightkey
              ? "Clone Shop"
              : "Add Shop"}
        </h1>
        {activeStep === 0 &&
          <div className="outer-box addmarket mb-15 text-center">
            <div className="mtb-10 ">
              <h2 className="dashboard-header"> {shopid !== "new" &&
                typeof parseInt(shopid) === type?.number &&
                !state?.cloneflightkey
                ? "Edit Your Shop"
                : shopid !== "new" &&
                  typeof parseInt(shopid) === type?.number &&
                  state?.cloneflightkey
                  ? "Clone Your Shop"
                  : "Create Your Shop"}</h2>
            </div>
            <SearchFlightShopForm isFromPreviousPage={isFromPreviousPage} isEditDataFetched={isEditDataFetched} activeStep={activeStep} selVal={selVal} setSelVal={setSelVal} handleCloseBulkSection={handleCloseBulkSection} />
            {state?.editFlightshop === true || state?.cloneflightkey === true ?
              <></>
              :
              <>
                <div className="mtb-10">
                  <p>OR</p>
                </div>

                <BulkImport uploadType="flight" table={"Shops"} isShowinsert={isShowinsert} setIsShowinsert={setIsShowinsert} isShowDownload={isShowDownload} setIsShowDownload={setIsShowDownload} />
              </>
            }
          </div>
        }
        {addFlightShopFormRenderCondition && flyFrom && flyTo && (
          <div className="outer-box addmarketstepper">
            <AddFlightShopForm activeStep={activeStep} setActiveStep={setActiveStep} setIsFromPreviousPage={setIsFromPreviousPage} />
          </div>
        )}
      </div>}
    </div >
  );
};

export default memo(AddFlightShop);